import { html, styleMap } from '@resn/gozer-core';
import { DomComponentMixin } from '@resn/gozer-core-mixins';
import { Component, componentMixin } from '@resn/gozer-core/component';
import svg from 'component/svg';
import { autobind } from 'core-decorators';
import { isMobile } from '@resn/gozer-env';
import store from 'core/store';
import TabsCursor from '../tabsCursor';
import './index.scss';

@componentMixin(DomComponentMixin)
class MaterialPicker extends Component {
    options = {
        template: ({ props, options }) => html`<div
            class="matPicker"
            style=${styleMap({
                '--c-border': options.cBorder,
                '--c-border-active': options.cBorderActive,
                '--c-cursor': options.cCursor,
                '--c-btn-background': options.cButtonBackground,

                '--border-width': `${options.borderWidth}px`,
                '--border-width-cursor': `${options.borderWidthCursor}px`,
                '--border-offset': `${options.borderOffset}px`,

                '--item-width': `${props.itemWidth}px`,
                '--item-height': `${props.itemHeight}px`,
            })}
        ></div>`,

        colors: [
            { color0: '#212121', color1: '#3C3C3C' },
            { color0: '#808080', color1: '#3B3B3B' },
            { color0: '#AD887B', color1: '#C7C7C7' },
        ],
        cBorder: null,
        cBorderActive: null,
        cCursor: null,
        cButtonBackground: null,

        borderWidth: 1,
        borderWidthCursor: 1,
        borderOffset: 10,
    };

    props = {
        index: 0,
        numItems: 3,
        size: { width: 1, height: 1 },

        itemSize: 120,
        itemWidth: (props) => ~~((props.itemSize - (isMobile ? 40 : 0)) * store().state.scale),
        itemHeight: (props) => ~~(props.itemWidth * (4 / 13)),
    };

    propsMotion = {
        pXCursorTg: 0,
        pXCursorVel: 0,
    };

    async onSetup() {
        const { colors } = this.options;

        this.items = await Promise.all(
            colors.map(async (_, i) => {
                return await new MaterialPickerItem().setup({
                    options: {
                        i,
                        appendTo: this.el,
                        handleItemClick: this.onItemClick,
                        ..._,
                    },
                    props: { selected: () => this.props.index == i },
                });
            }),
        );

        this.cursor = await new TabsCursor().setup({
            options: {
                appendTo: this.el,
                prefix: 'matPicker',
            },
            props: {
                h: null,
                w: null,

                pXMotion: 0,
                pX: (props) => props.pXMotion,
            },
        });

        this.observer = new ResizeObserver((entries) => {
            const rect = entries[0].contentRect;
            const { width, height } = rect;
            this.props.size = { width, height };

            this.items.forEach((it) => it.updateLayout());

            this.updateIndex(this.props.index);
        });
    }

    onActive() {
        this.observer.observe(this.el);
    }
    offActive() {
        this.observer.unobserve(this.el);
    }
    onDestroy() {
        this.observer.disconnect();
    }

    @autobind
    onItemClick(i) {
        this.props.index = i;
    }

    setIndex(i) {
        if (this.options.handlerIndexChange) this.options.handlerIndexChange(i);
        this.updateIndex(i);
    }

    updateIndex(i) {
        const { x } = this.items[i].props.bounds;
        this.propsMotion.pXCursorTg = ~~x;
    }

    whileActive() {
        if (Math.abs(this.propsMotion.pXCursorTg - this.cursor.props.pX) < 0.001)
            this.cursor.props.pXMotion = this.propsMotion.pXCursorTg;
        this.propsMotion.pXCursorVel += (this.propsMotion.pXCursorTg - this.cursor.props.pXMotion) * 0.06;
        this.cursor.props.pXMotion += this.propsMotion.pXCursorVel *= 0.64;
    }
}

export default MaterialPicker;

@componentMixin(DomComponentMixin)
class MaterialPickerItem extends Component {
    options = {
        template: ({ options, props }) => html`<button
            class="matPicker__item"
            ?selected=${props.selected}
            style=${styleMap({
                '--color0': options.color0,
                '--color1': options.color1,
            })}
            @pointerdown=${(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
            @click=${() => options.handleItemClick(options.i)}
        >
            ${svg('mat', 'matPicker__icon')}
        </button>`,
    };

    props = {
        bounds: { x: 0, y: 0 },
    };

    async onSetup() {}

    updateLayout() {
        this.props.bounds = {
            x: this.el.offsetLeft,
            y: 0,
        };
    }
}
